export type { PartnershipForm } from './lib/partnership';
export { getInitialValues, validationSchema as partnershipValidationSchema } from './lib/partnership';
